import { useResponsive } from '../hooks/useResponsive';
import { colors, typography, } from '../utils/styling';
import { View, } from 'react-native-web';

const RainbowText = ({ text }: { text: string }) => {
  const { isMobile } = useResponsive();
  return (
    <span style={{
      margin: 0,
      fontSize: isMobile ? 48 : 120,
      fontWeight: '300',
      fontFamily: typography.fontFamily.body,
      backgroundImage: "linear-gradient(to right, #00A4EF 0%, #9933FF 28%, #FF00FF 54%, #00B3C2 78%, #00FF33 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundClip: "text",
      display: "inline-block",
    }}>
      {text}
    </span>
  );
};

export default function About() {
  return(
    <View style={{ flex: 1, backgroundColor: colors.white, minHeight: '100vh', position: 'relative', alignItems: 'center', width: '100%' }}>
      <View style={{
        marginTop: 100,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
      }}>
        <h1 style={{margin: 0, fontFamily: "Nunito", fontWeight: 700, fontSize: 100}}> This page is </h1>
        <RainbowText text="under construction"/>
      </View>
    </View>
  );
}